import { TextFieldModule } from '@angular/cdk/text-field';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { CustomButtonComponent } from '../custom-button/custom-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CustomInputComponent } from '../custom-input/custom-input.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { CommonModule } from '@angular/common';
import { CustomSelectComponent } from '../custom-select/custom-select.component';
import { LoginService } from '../../services/login/login.service';
import { AuthService } from '../../services/auth/auth.service';
import { CustomLoadingDialogComponent } from '../custom-loading-dialog/custom-loading-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-select-warehouse-dialog',
  standalone: true,
  imports: [
    TextFieldModule,
    CustomButtonComponent,
    CustomInputComponent,
    MatButtonModule,
    MatIconModule,
    FormsModule, 
    MatFormFieldModule, 
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
    CustomSelectComponent
  ],
  templateUrl: './select-warehouse-dialog.component.html',
  styleUrl: './select-warehouse-dialog.component.scss'
})
export class SelectWarehouseDialogComponent implements OnInit{
  public ELEMENT_IDS = ELEMENT_IDS;

  readonly dialogRef = inject(MatDialogRef<SelectWarehouseDialogComponent>);
  protected readonly loadingDialog = inject(MatDialog);
  
  inputForm!: FormGroup;
  
  warehouseData: any[] = []

  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackbarService,
    private loginService: LoginService,
    private snackbarService: SnackbarService,
    private authService: AuthService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  
  ngOnInit(): void {
    this.initForm();
    this.getFilterData();
  }

  initForm() {
    this.inputForm = this.fb.group({
      warehouse: ['', Validators.required],
    });
  }

  getFilterData() {
    const data = this.loginService.availableWarehouse;
    this.warehouseData = data;
  }

  onSubmit(){
    this.inputForm.markAllAsTouched();
    if (!this.inputForm.valid) {
      this.snackBarService.show('Please select a warehouse.', 'close')
      return	
    }

    const value = this.inputForm.get('warehouse')?.value;

    if (!value) {
      console.error("Value cant be null.", value)
      return;
    }
    
    const currentSelectedWarehouse = this.getDefaultValue();

    if (value.code == currentSelectedWarehouse.code) {
      console.log("This warehouse is already in use. ", value.code, " : ", currentSelectedWarehouse.code)
      return;
    }

    this.onWarehouseSelect(value);
    this.dialogRef.close()
  }

  onClose(){
    this.dialogRef.close();  
  }

  getDefaultValue() {
    const selectedWarehouse = this.loginService.selectedWarehouse;
    const defaultValue = this.warehouseData.find((item) => {
      return item.code === selectedWarehouse
    })
    return defaultValue;
  }

  onWarehouseSelect(warehouse: any): void {
    // localStorage.setItem('warehouse_code', warehouse['code']);
    this.getUserDetail(warehouse);
  }

  private getUserDetail(warehouseData: any): void {
    const warehouse_db_schema = warehouseData['database_schema'];
    const warehouse_code = warehouseData['code']

    // add handling of error, reset selected modules
    let parameters = {
        "warehouse_db_schema": warehouse_db_schema
    };
    const loadingDialogRef = this.loadingDialog.open(CustomLoadingDialogComponent, {
          data: 'Loading..',
          disableClose: true,
        });
    this.loginService.login(parameters).subscribe({
          next: (res) => {
            
          this.loginService.selectedWarehouse = warehouse_code;

          this.snackbarService.closeAllSnackbar()
          this.authService.saveUserDetails(res);
          this.router.navigate(['/']);
          loadingDialogRef.close();
          this.snackBarService.show("Warehouse switched successfully");
          this.loginService.notifyWarehouseChanged();
        },
        error: () => {
          this.snackBarService.show("Error switching warehouse. Please try again later.");
          loadingDialogRef.close();
        }
    });
  }

  disableConfirm() {
    const value = this.inputForm.get('warehouse')?.value;
    const currentSelectedWarehouse = this.getDefaultValue();

    if(value.code == currentSelectedWarehouse.code) {
      return true;
    }

    this.inputForm.markAllAsTouched();

    if (this.inputForm.invalid) {
      return true;
    }

    return false;
  }
  
}

const BASE_ELEMENT_ID: string = 'id_select_warehouse_dialog';
export const ELEMENT_IDS: { [key: string]: string } = {
  'dlg':                BASE_ELEMENT_ID + '_dlg',
  'lbl_title':          BASE_ELEMENT_ID + '_lbl_title',
  'btn_close':          BASE_ELEMENT_ID + '_btn_close',
  'dropdown_warehouse': BASE_ELEMENT_ID + '_dropdown_warehouse',
  'btn_cancel':         BASE_ELEMENT_ID + '_btn_cancel',
  'btn_confirm':        BASE_ELEMENT_ID + '_btn_confirm',
};